import { IDObserverTimerSession } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

export class DObserverTimerSessionApp implements IDObserverTimerSession {
    
    constructor(
        private dNotificacionServicio: DNotificacionServicio,
        private dContextoUsuarioServicio: DContextoUsuarioServicio
    ) {}
    
    public cerrarSession(){
        let dialogo = this.dNotificacionServicio.mostrarDialogoInformacion('Su sesión ha expirado');
        dialogo.afterClosed().subscribe(result => {
            this.dContextoUsuarioServicio.logOut();
        });
    }
}


// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/configuracion/dformulario-configuracion.ts